import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { getOrders, getOrder } from "../actions/orderActions";
import { setPager } from "../actions/pagerActions";
import { withRouter } from "react-router";
import { utils } from "../common/utils";
import { OrderStatusEnum, OrderRefundStatusEnum } from "../common/enums";
import { Breakpoint } from 'react-socks';
import { withTranslation } from 'react-i18next';
import CurrencyFormat from '../components/CurrencyFormat';

class OrdersList extends Component {

    componentDidMount() {
        this.props.getOrders(
            1,
            this.props.settings.pageSize,
            this.props.user.id
        );
    }

    onRowClick(orderId) {
        this.props.getOrder(orderId).then((response) => {
            this.props.onSelectOrder(orderId);
            utils.scrollTop();
        }, (error) => {
            console.log(error)
        });
    }

    getStatus(o) {

        return o.refundStatus === OrderRefundStatusEnum.None ? utils.orders.getOrderStatusString(o.status)
            : utils.orders.getOrderRefundStatusString(o.refundStatus);
    }

    getStatusColor(order) {
        if (order.status === OrderStatusEnum.Cancelled || order.refundStatus !== OrderRefundStatusEnum.None)
            return "text-danger";
        else if (order.status === OrderStatusEnum.Ordered)
            return "text-warning";
        else if (order.status === OrderStatusEnum.Dispatched)
            return "text-success";
        return "text-info";
    }

    render() {
        const { t, orders, settings } = this.props;
        if (!orders || orders.items.length === 0)
            return (<div className="alert alert-info fade show text-center margin-bottom-1x">
                <span className="alert-close" data-dismiss="alert"></span>
                <i className="icon-layers"></i>&nbsp;&nbsp;<strong>{t("My Orders")}:</strong> {t("You don't have any orders")}.
                </div>);

        const isProductPricesIncludeTax = orders.items[0].isProductPricesIncludeTax;


        return (
            <Fragment>
                <Breakpoint small down>
                    <div className="accordion padding-top-1x" role="tablist">
                        {orders.items.map(o => (
                            <div className="card" key={o.id}>
                                <div className="card-header" role="tab">
                                    <h6>
                                        <a
                                            href={`#collapse${o.id}`}
                                            data-toggle="collapse"
                                            data-parent="#accordion2">
                                            <span className={`badge badge-pill ${this.getStatusColor(o)}`}>{t(this.getStatus(o))}</span> #{o.id}
                                            <span className="text-medium">&nbsp;&nbsp;&nbsp;Total:&nbsp;<CurrencyFormat value={o.orderTotalAfterDiscount} settings={settings} /></span>
                                        </a>
                                    </h6>
                                </div>
                                <div className="collapse show" id={`#collapse${o.id}`} role="tabpanel">
                                    <div className="card-body">
                                        <div className="padding-bottom-1x">
                                            <span >{t("Date Purchased")}:&nbsp;</span>
                                            <span className="text-medium">{utils.dates.getDateTime24String(o.orderedAt)}</span>
                                        </div>
                                        <div className="padding-bottom-1x">
                                            <span >{t("Total Customer Price")}:&nbsp;</span>
                                            <span className="text-medium">
                                                <CurrencyFormat value={o.totalCustomerPriceBeforeDiscountCode} settings={settings} />
                                                 
                                            </span>
                                        </div>
                                        <div className={`padding-bottom-1x ${o.hasDiscountCodes ? "" : "hide"}`}>
                                            <span >{t("Discount")}:&nbsp;</span>
                                            <span className="text-medium">
                                                <CurrencyFormat value={o.totalDiscountCodeAmount} settings={settings} />
                                            </span>
                                        </div>
                                        <div className="padding-bottom-1x">
                                            <span>{t("Total Delivery Fees")}:&nbsp;</span>
                                            <span className="text-medium">
                                                <CurrencyFormat value={o.totalDeliveryFees} settings={settings} />
                                                 </span>
                                        </div>
                                        <div className={`padding-bottom-1x ${isProductPricesIncludeTax ? "hide" : ""}`}>
                                            <span>{t("Total PST Tax")}:&nbsp;</span>
                                            <span className="text-medium">  <CurrencyFormat value={o.totalPSTTaxValue} settings={settings} />
                                                 </span>
                                        </div>
                                        <div className={`padding-bottom-1x ${isProductPricesIncludeTax ? "hide" : ""}`}>
                                            <span>{t("Total HSTGST Tax")}:&nbsp;</span>
                                            <span className="text-medium">  <CurrencyFormat value={o.totalHSTGSTTaxValue} settings={settings} />
                                                 </span>
                                        </div>
                                        <div className="padding-bottom-1x">
                                            <span>{t("Total")}:&nbsp;</span>
                                            <span className="text-medium">  <CurrencyFormat value={o.orderTotalAfterDiscount} settings={settings} />
                                                </span>
                                        </div>
                                        <div className="padding-bottom-1x">
                                            <span>{t("Total Points")}:&nbsp;</span>
                                            <span className="text-medium">{o.totalPoints}</span>
                                        </div>
                                        <div className="padding-bottom-1x">
                                            <span>{t("Date Dispatched")}:&nbsp;</span>
                                            <span className="text-medium">{utils.dates.getDateTime24String(o.dispatchedAt)}</span>
                                        </div>
                                        <div className="padding-bottom-1x">
                                            <button className="btn btn-info" onClick={() => this.onRowClick(o.id)}>{t("More Details")}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Breakpoint>
                <Breakpoint medium up>
                    <div className="padding-top-2x mt-2 hidden-lg-up"></div>
                    <div className="table-responsive">
                        <table className="table table-hover margin-bottom-none text-center">
                            <thead>
                                <tr>
                                    <th>{t("Order #")}</th>
                                    <th>{t("Date Purchased")}</th>
                                    <th>{t("Status")}</th>
                                    <th>{t("Total Customer Price")}</th>
                                    <th>{t("Discount")}</th>
                                    <th>{t("Total Delivery Fees")}</th>
                                    <th className={`${isProductPricesIncludeTax ? "hide" : ""}`}>{t("Total PST Tax")}</th>
                                    <th className={`${isProductPricesIncludeTax ? "hide" : ""}`}>{t("Total HSTGST Tax")}</th>
                                    <th>{t("Total")}</th>
                                    <th>{t("Total Points")}</th>
                                    <th>{t("Date Dispatched")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.items.map(o => (
                                    <tr key={o.id} onClick={() => this.onRowClick(o.id)} className='clickable'>
                                        <td><a className="text-medium navi-link" href={null} role="button" data-toggle="modal" data-target="#orderDetails">{o.id}</a></td>
                                        <td>{utils.dates.getDateTime24String(o.orderedAt)}</td>
                                        <td><span className={this.getStatusColor(o)}>{t(this.getStatus(o))}</span></td>
                                        <td><span className="text-medium">
                                            <CurrencyFormat value={o.totalCustomerPriceBeforeDiscountCode} settings={settings} />
                                             </span></td>
                                        <td><span className="text-medium">
                                                <CurrencyFormat value={o.totalDiscountCodeAmount} settings={settings} />
                                             </span>
                                        </td>
                                        <td><span className="text-medium">
                                            <CurrencyFormat value={o.totalDeliveryFees} settings={settings} />
                                            </span></td>
                                        <td className={`${isProductPricesIncludeTax ? "hide" : ""}`}><span className="text-medium">
                                            <CurrencyFormat value={o.totalPSTTaxValue} settings={settings} />
                                             </span></td>
                                        <td className={`${isProductPricesIncludeTax ? "hide" : ""}`}><span className="text-medium">
                                            <CurrencyFormat value={o.totalHSTGSTTaxValue} settings={settings} />
                                             </span></td>
                                        <td><span className="text-medium">
                                            <CurrencyFormat value={o.orderTotalAfterDiscount} settings={settings} />
                                          </span></td>
                                        <td><span className="text-medium">{o.totalPoints}</span></td>
                                        <td>{utils.dates.getDateTime24String(o.dispatchedAt)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Breakpoint>
            </Fragment>
        );
    }
}

function mapStateToProps({ orders, settings, user }, ownProps) {
    return { orders, settings, user, ...ownProps };
}

export default withTranslation()(withRouter(
    connect(mapStateToProps, { getOrders, getOrder, setPager })(OrdersList))
);
